<template>
  <div class="ksm-texte__layout-wrapper">
    <div class="ksm-flex-1 ksm-flex" @mousemove="dragMove" @mouseup="dragStop">
      <!-- 3 column  start-->
      <div ref="sidebar-1" v-if="cols==3" :style="styleSidebar1" class="ksm_texte__layout-sidebar">
        <slot name="sidebar-1"></slot>
      </div>
      <div v-if="cols==3" class="ksm-resizer-wrapper--left">
        <div class="ksm-resizer" style="left:0" @mousedown="dragStart($event,true)">
          <div class="__pointer" :class="modus" @click="setCollapseLeft" v-html="$_getIcon(leftCollapse?'arrow-right-2.svg':'arrow-left-2.svg')"></div>
        </div>
      </div>
      <!-- 3 column  end -->
      <div class="ksm-texte__layout--main">
        <slot name="main-content">main slot in layout</slot>
      </div>
      <div class="ksm-resizer-wrapper">
        <div class="ksm-resizer" :class="rightCollapse?'active':''" @mousedown="dragStart">
          <div class="__pointer" :class="modus" @click="setCollapseRight" v-html="$_getIcon(rightCollapse?'arrow-left-2.svg':'arrow-right-2.svg')"></div>
        </div>
      </div>
      <div ref="sidebar-2" :style="styleSidebar2" class="ksm_texte__layout-sidebar">
        <slot name="sidebar-2"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cols: Number,
    sidebar_left_collapse: Boolean,
    sidebar_right_collapse: Boolean,
    sidebar_left_width: String,
    sidebar_right_width: String,
    group: Number
  },
  data() {
    return {
      minWidthSidebar1: 250,
      maxWidthSidebar1: 800,
      minWidthSidebar2: 250,
      maxWidthSidebar2: 800,
      widthRight: null,
      widthLeft: null,
      leftCollapse: false,
      rightCollapse: false,
      leftMove: null,
      startSplit: null,
      startPos: null,
      dragging: false
    };
  },
  mounted: function() {
    if (this.cols == 3) {
      this.widthLeft = this.$refs["sidebar-1"].clientWidth;
    }
    this.widthRight = this.$refs["sidebar-2"].clientWidth;
    this.leftCollapse = this.sidebar_left_collapse;
    this.rightCollapse = this.sidebar_right_collapse;
    let vue = this;
    this.$store.state.eventBus.$on(
      "splitlayout-sidebar-open" + this.group,
      id => {
        if (id == 1) {
          this.leftCollapse = false;
        } else if (id == 2) {
          this.rightCollapse = false;
        }
      }
    );
  },
  watch: {},
  methods: {
    setCollapseRight() {
      this.rightCollapse = !this.rightCollapse;
      let s = this.$refs["sidebar-2"];
      s.classList.add("animation");
      setTimeout(function() {
        s.classList.remove("animation");
      }, 300);
      this.$emit("clickCollapse");
    },
    setCollapseLeft() {
      this.leftCollapse = !this.leftCollapse;
      let s = this.$refs["sidebar-1"];
      s.classList.add("animation");
      setTimeout(function() {
        s.classList.remove("animation");
      }, 300);
      this.$emit("clickCollapse");
    },
    dragStart(e, isLeft) {
      e.preventDefault();
      this.dragging = true;
      this.startPos = e.pageX;
      if (isLeft) {
        this.startSplit = this.widthLeft;
      } else {
        this.startSplit = this.widthRight;
      }
      this.leftMove = isLeft;
      e.target.classList.add("movie");
      e.stopPropagation();
    },
    dragMove(e) {
      if (this.dragging) {
        e.preventDefault();
        let dx = e.pageX - this.startPos;
        if (this.leftMove) {
          this.widthLeft = this.startSplit + dx;
        } else {
          this.widthRight = this.startSplit - dx;
        }
        e.stopPropagation();
      }
    },
    dragStop(e) {
      e.target.classList.remove("movie");
      if (this.dragging) {
        e.preventDefault();
        this.dragging = false;
        e.stopPropagation();
        this.$emit("dragStop");        
        this.$store.state.eventBus.$emit('dragStop');
      }
    }
  },
  computed: {
    defaultStyleSidebar() {
      return this.cols === 2 ? "width:30%" : "width:20%";
    },
    modus() {
      return this.$route.params.modus;
    },
    styleSidebar1() {
      if (this.widthLeft == null) {
        return this.sidebar_left_width
          ? this.sidebar_left_width
          : this.defaultStyleSidebar;
      } else {
        return "width:" + this.widthSidebar1;
      }
    },
    widthSidebar1() {
      if (this.leftCollapse) {
        return "0px";
      }

      if (this.widthLeft < this.minWidthSidebar1) {
        return this.minWidthSidebar1 + "px";
      }

      if (this.widthLeft > this.maxWidthSidebar1) {
        return this.maxWidthSidebar1 + "px";
      }
      return this.widthLeft + "px";
    },

    styleSidebar2() {
      if (this.widthRight == null) {
        return this.sidebar_right_width
          ? this.sidebar_right_width
          : this.defaultStyleSidebar;
      } else {
        return "width:" + this.widthSidebar2;
      }
    },
    widthSidebar2() {
      if (this.rightCollapse) {
        return "0px";
      }
      if (this.widthRight < this.minWidthSidebar2) {
        return this.minWidthSidebar2 + "px";
      }

      if (this.widthRight > this.maxWidthSidebar2) {
        return this.maxWidthSidebar2 + "px";
      }
      return this.widthRight + "px";
    }
  }
};
</script>

<style lang="scss">
$gutterSize: 10px;

.ksm-texte__shadow--right {
  -webkit-box-shadow: 8px 0px 5px 0px rgba(0, 0, 0, 0.6);
  -moz-box-shadow: 8px 0px 5px 0px rgba(0, 0, 0, 0.6);
  box-shadow: 8px 0px 5px 0px rgba(0, 0, 0, 0.6);
}

.ksm-texte__shadow--left {
  -webkit-box-shadow: -8px 0px 5px 0px rgba(0, 0, 0, 0.6);
  -moz-box-shadow: -8px 0px 5px 0px rgba(0, 0, 0, 0.6);
  box-shadow: -8px 0px 5px 0px rgba(0, 0, 0, 0.6);
}

.ksm-texte__layout-wrapper {
  @extend .ksm-flex-1;
  @extend .ksm-flex-column;
  position: relative;
  background-color: #eee;
}

.ksm-texte__layout--main {
  @extend .ksm-flex-1;
  position: relative;
}
.ksm-resizer-wrapper {
  @extend .ksm-flex-00auto;
  position: relative;
  width: $gutterSize;
  &:hover {
    img {
      opacity: 1 !important;
      transition: opacity 0s !important;
    }
  }
  @extend .ksm-texte__shadow--right;
}

.ksm-resizer-wrapper--left {
  @extend .ksm-flex-00auto;
  position: relative;
  width: $gutterSize;
  &:hover {
    img {
      opacity: 1 !important;
      transition: opacity 0s !important;
    }
  }
  @extend .ksm-texte__shadow--left;
}

.ksm-resizer {
  @extend .ksm-flex-xy-center;
  width: $gutterSize;
  background-color: #ccc;
  position: absolute;
  height: 100%;
  right: 0px;
  cursor: col-resize;

  // &.active {
  //   background-color: rgb(214, 214, 159);
  // }

  &:hover {
    background-color: rgb(173, 170, 170);
  }

  .__pointer {
    @extend .ksm-flex-xy-center;
    height: auto;
    width: 100%;
    z-index: 100;

    cursor: pointer;
    svg {
      width: 100%;
      height: 100px;
      polygon {
        fill: #fff;
      }
      &:hover {
        polygon {
          fill: #bbb;
        }
      }
    }
  }

  .__pointer.ansichtsmodus {
    svg {
      background-color: $ansicht-color;
    }
  }
  .__pointer.vergleichsmodus {
    svg {
      background-color: $vergleich-color;
    }
  }

  .__pointer.untersuchungsmodus {
    svg {
      background-color: $untersuchung-color;
    }
  }

  .__pointer.kompositionsmodus {
    svg {
      background-color: $komposition-color;
    }
  }

  .__pointer--left {
    @extend .__pointer;
    margin-right: -60px;
  }
}

.ksm_texte__layout-sidebar {
  background-image: url("../../static/icons/kachel-akkordeon.png");
  background-repeat: repeat;
  @extend .ksm-flex;
  &.animation {
    transition: width 0.4s;
  }
}
</style>


// WEBPACK FOOTER //
// SplitLayout.vue?6376e0d4